import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Moment } from 'moment';
import { map } from 'rxjs/operators';
import { isArray } from 'util';

import { environment } from '../../../../environments/environment';
import { WorkingShiftDateRangeBuilder } from '../../models/builders/working-shift-date-range.builder';
import { WorkingShiftBuilder } from '../../models/builders/working-shift.builder';
import { WorkingShift } from '../../models/calendar/working-shift';
import { WorkingShiftDateRangeHourRange } from '../../models/calendar/working-shift-date-range-hour-range';
import { getFirstMillisOfDate, getLastMillisOfDate, getMomentWithFormat } from '../../utils/date.utils';

const saveWorkingShiftDateRangeHourRangeBody = (hourRanges: WorkingShiftDateRangeHourRange[]) => {
  return (isArray(hourRanges))
    ? hourRanges.map(
      hourRange => {
        const startTime = hourRange.startTime;
        const momentStartTime: Moment = getMomentWithFormat(startTime, 'hh:mm:ss');
        const momentStartTimeDate = getFirstMillisOfDate(startTime);
        const endTime = hourRange.endTime;
        const momentEndTime: Moment = getMomentWithFormat(endTime, 'hh:mm:ss');
        const momentEndTimeDate = getFirstMillisOfDate(endTime);
        const start = momentStartTime.valueOf() - momentStartTimeDate;
        const end = momentEndTime.valueOf() - momentEndTimeDate;
        return (
          {
            startTime: start,
            endTime: end
          }
        );
      }
    )
    : [];
};

const saveWorkingShiftDateRangeBody = (dateRanges: any[]) => {
  return (isArray(dateRanges))
    ? dateRanges.map(dateRangeElement => ({
      startDate: getFirstMillisOfDate(dateRangeElement.dateRange[0]),
      endDate: getLastMillisOfDate(dateRangeElement.dateRange[1]),
      hourRanges: saveWorkingShiftDateRangeHourRangeBody(dateRangeElement.hourRanges)
    }))
    : [];
};

const workingShiftBody = (workingShift: WorkingShift) => ({
  name: workingShift.name,
  dateRanges: saveWorkingShiftDateRangeBody(workingShift.workingShiftDateRanges)
});

@Injectable()
export class WorkingShiftApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}calendar/working-shifts`;
  }

  createWorkingShift(workingShift: WorkingShift) {
    return this.httpClient.post(`${this.apiUrl}/date-ranges`, workingShiftBody(workingShift)).pipe(map(WorkingShiftBuilder.fromJson));
  }

  deleteWorkingShift(workingShift: WorkingShift) {
    return this.httpClient.delete(`${this.apiUrl}/${workingShift.hash}`);
  }

  getWorkingShifts() {
    return this.httpClient.get(`${this.apiUrl}`).pipe(map(WorkingShiftBuilder.fromList));
  }

  updateWorkingShift(workingShift: WorkingShift) {
    return this.httpClient.put(`${this.apiUrl}/date-ranges/${workingShift.hash}`, workingShiftBody(workingShift));
  }

  getWorkingShift(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(
        map(WorkingShiftBuilder.fromJson)
      );
  }

  getWorkingShiftDateRanges(year: number, workingShift: string) {
    const params = new HttpParams().append('year', year.toString())
      .append('workingShift', workingShift);

    return this.httpClient.get(`${this.apiUrl}/date-ranges`, { params })
      .pipe(
        map(WorkingShiftDateRangeBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/working-shift-api.service.ts